module.exports = __webpack_public_path__ + "img/stepicons-install.21dce349.svg";